import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MemoryRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Bridge from './App/Bridge';

const root = createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<StrictMode>
		<MemoryRouter initialEntries={['/' + Bridge.getRoute()]}>
			<App />
		</MemoryRouter>
	</StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
